import styled from 'styled-components';

export const ReceiptDetail = styled.div<{ $total?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin-top: ${p => (p.$total ? '0.8rem' : 0)};

  p {
    margin: 0;
  }
`;

export const FeeDeliveryItem = styled.p`
  margin: 0;
  text-transform: ${Styles.textTransform.headlines};
`;

export const RewardsDiscountDetail = styled(ReceiptDetail)`
  p {
    color: ${Styles.color.validated};
    font-family: ${Styles.fontFamily.brand};
  }
`;
